import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

// Admin subtree gate. Runs after the `_authed` gate. Admins reach every
// section; moderators may reach ONLY the moderation queue, since every other
// admin surface is `requireAdmin` server-side and we keep the web gate in
// lockstep (see `moderation/authz.ts`, which authorizes moderator OR admin).
// Anyone else lands back on /feed so the UX stays inside the product surface;
// a moderator who wanders to an admin-only section is sent to their queue.
// The route renders only an <Outlet/> — the intra-admin sidebar nav lives in
// `AdminShell`, mounted by each /admin/* view.
const MODERATION_PREFIX = '/admin/moderation';

export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: ({ context, location }) => {
    const role = context.member.platformRole;
    if (role === 'admin') return;
    const isModeration =
      location.pathname === MODERATION_PREFIX ||
      location.pathname.startsWith(`${MODERATION_PREFIX}/`);
    if (role === 'moderator' && isModeration) return;
    throw redirect({ to: role === 'moderator' ? MODERATION_PREFIX : '/feed' });
  },
  component: Outlet,
});
